export { default as AccessoryItem } from "./accessory-item";
export type { AccessoryItemProps } from "./accessory-item";
